import { render, staticRenderFns } from "./CompanyArticle.vue?vue&type=template&id=c84b01c0&"
var script = {}
import style0 from "./CompanyArticle.vue?vue&type=style&index=0&id=c84b01c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports